import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Button, Icon } from "semantic-ui-react";
import { PDFDocument, rgb } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import userEvent from "@testing-library/user-event";

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

const Details = ({ resultType, userInfo }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [personalizedPdfUrl, setPersonalizedPdfUrl] = useState(null);

  const filePath = `${process.env.PUBLIC_URL}/pdfs/${resultType.toLowerCase().replace(/\s/g, "")}.pdf`;

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  const goToPrevPage = () => setPageNumber((prev) => Math.max(prev - 1, 1));
  const goToNextPage = () =>
    setPageNumber((prev) => Math.min(prev + 1, numPages));

  const generatePersonalizedPdf = async (userInfo) => {
    const { full_name, email, company, role } = userInfo;

    const existingPdfBytes = await fetch(filePath).then((res) =>
      res.arrayBuffer(),
    );
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const coverPdf = await PDFDocument.create();
    coverPdf.registerFontkit(fontkit);
    const page = coverPdf.addPage([595.28, 841.89]); // A4

    // PNG görseli ekle
    const imageBytes = await fetch(`${process.env.PUBLIC_URL}/kapak.png`).then(
      (res) => res.arrayBuffer(),
    );
    const pngImage = await coverPdf.embedPng(imageBytes);
    const pngDims = pngImage.scale(1);

    // PNG'yi sayfanın üstüne, oranı bozmadan yerleştir
    const maxWidth = 595.28;
    const scaled = pngImage.scale(maxWidth / pngDims.width);
    const imageHeight = scaled.height;

    page.drawImage(pngImage, {
      x: 0,
      y: 841.89 - imageHeight,
      width: maxWidth,
      height: imageHeight,
    });

    // Font ve yazılar (Türkçe karakterler için Roboto embed ediliyor)
    const fontBytes = await fetch(
      `${process.env.PUBLIC_URL}/fonts/custom/Roboto-Regular.ttf`,
    ).then((res) => res.arrayBuffer());
    const font = await coverPdf.embedFont(fontBytes);
    const textSize = 16;
    const textGap = 30;
    const centerX = 300;
    const texts = [
      `Ad Soyad: ${full_name ?? ""}`,
      `Email: ${email ?? ""}`,
      `Sirket: ${company ?? ""}`,
      `Pozisyon: ${role ?? ""}`,
    ];

    const startY = (841.89 - imageHeight) / 2 + (texts.length * textGap) / 2;

    const title = "Quders Q-Test Raporu";
    const titleSize = 26;
    const titleWidth = font.widthOfTextAtSize(title, titleSize);

    // Başlık, bilgilerden yukarıda ama kapak görselinin altına taşmamalı
    page.drawText(title, {
      x: centerX - titleWidth / 2,
      y: startY + textGap + 10, // Bilgi satırlarının üstü + biraz boşluk
      size: titleSize,
      font,
      color: rgb(0, 0.2, 0.5),
    });

    texts.forEach((text, i) => {
      const y = startY - i * textGap;
      const textWidth = font.widthOfTextAtSize(text, 16);
      page.drawText(text, {
        x: centerX - textWidth / 2,
        y,
        size: 16,
        font,
        color: rgb(0.1, 0.1, 0.1),
      });
    });
    // PDF birleştir
    const finalPdf = await PDFDocument.create();
    const [coverPage] = await finalPdf.copyPages(coverPdf, [0]);
    finalPdf.addPage(coverPage);

    const copiedPages = await finalPdf.copyPages(
      pdfDoc,
      pdfDoc.getPageIndices(),
    );
    copiedPages.forEach((p) => finalPdf.addPage(p));

    const pdfBytes = await finalPdf.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    setPersonalizedPdfUrl(url);

    const a = document.createElement("a");
    a.href = url;
    a.download = `KisiselTestSonucu.pdf`;
    a.click();
  };

  return (
    <div style={{ textAlign: "center" }}>
      <div
        style={{
          marginTop: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "1rem",
        }}
      >
        <Button onClick={goToPrevPage} disabled={pageNumber === 1}>
          <Icon name="arrow left" /> Geri
        </Button>

        <span>
          Sayfa {pageNumber} / {numPages}
        </span>

        <Button onClick={goToNextPage} disabled={pageNumber === numPages}>
          İleri <Icon name="arrow right" />
        </Button>

        <Button
          icon="download"
          content="Kişisel PDF İndir"
          color="blue"
          onClick={() => generatePersonalizedPdf(userInfo)}
        />
      </div>
      {/* <Button
    as="a"
    href={filePath}
    target="_blank"
    rel="noopener noreferrer"
    download
    icon="download"
    content="PDF İndir"
    color="teal"
  />
 */}

      <Document
        //file={filePath}
        file={personalizedPdfUrl || filePath}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<div style={{ padding: "2rem" }}>Yükleniyor...</div>}
      >
        <Page
          pageNumber={pageNumber}
          width={Math.min(window.innerWidth * 0.9, 1100)}
        />
      </Document>

      {/* <Document
    file={filePath}
    onLoadSuccess={onDocumentLoadSuccess}
    loading={<div style={{ padding: "2rem" }}>Yükleniyor...</div>}
        >
        <Page pageNumber={pageNumber}   width={Math.min(window.innerWidth * 0.9, 1100)} />
      </Document> */}
    </div>
  );
};

export default Details;
